import { Component, OnInit, ViewChild, Renderer2 } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Table } from "primeng/table";
import { TableModule } from "primeng/table";
import { UserWalletService } from "src/app/services/userWallet.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { LazyLoadEvent } from "primeng/api";
import { environment } from "src/environments/environment";
import { ConfirmationService, MessageService } from "primeng/api";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import { CustomValidators } from "ng2-validation";
import { WindowRefService } from "src/app/services/window-ref.service";
import { WalletpaymentService } from "src/app/services/walletPayments.service";
import { UserService } from "src/app/services/user.service";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { Subject, Subscription } from "rxjs";

interface WalletCashType {
  name: string,
  value: string
}
@Component({
  selector: "app-wallet",
  templateUrl: "./wallet.component.html",
  styleUrls: ["./wallet.component.scss"],
  providers: [ConfirmationService, MessageService, WindowRefService],
})
export class WalletComponent implements OnInit {
    position: 'left' | 'right' | 'top' | 'bottom' | 'center' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright' = 'center';
       public downloadModal: boolean = false;
  availableClasses: string[] = ["body-dark", "bg-white", ""];
  currentClassIdx: number = 0;
  bodyClass: string;
  public walletlist: any = [];
  public loading: boolean;
  public totalRecords = 0;
  errorMessage: string;
  public loggedInUser;
  paginationOption;
  downloadFlg: boolean;
  totalCoins;
  totalDeductedCoin;
  totalAvailableCoins;
  totalCash;
  totalDeductedCash;
  addCashmodal: boolean = false;
  showThankyouModal: boolean = false;
  addCoinmodal: boolean = false;
  totalAvailableCash;
  private lastTableLazyLoadEvent: LazyLoadEvent;
  public userId;
  addCashOrContestCashForm: FormGroup;
  addCoinForm: FormGroup;
  submitted = false;
  coinsubmitted = false;
  @ViewChild("dt", { static: false }) public dt: Table;
  userAge: any;
  totalContestCash: any;
  totalDeductedContestCash: any;
  totalAvailableContestCash: number;
  paymentHeader: string;
  walletCashTypeArray:WalletCashType[];
  walletCashTypeFilterOption:WalletCashType = { name:'All', value:'ALL'};
  isWalletCashTypeTabChanged: boolean = false;
  pageNumberFirst: number = 1;
  pageLimitFirst: number = 10;
  private searchSubject = new Subject<string>();
  private searchSubscription!: Subscription;
  descriptionName: string = null;
  
  constructor(
    private tokenStorage: TokenStorageService,
    private route: ActivatedRoute,
    private userWalletService: UserWalletService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private winRef: WindowRefService,
    private router: Router,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private walletpaymentService: WalletpaymentService,
    private renderer: Renderer2
  ) {
    this.bodyClass = this.availableClasses[this.currentClassIdx];
    this.changeBodyClass();
  }
  changeBodyClass() {
    // get html body element
    const bodyElement = document.body;

    if (bodyElement) {
      this.currentClassIdx = this.getNextClassIdx();
      const nextClass = this.availableClasses[this.currentClassIdx];
      const activeClass = this.availableClasses[this.getPrevClassIdx()];

      // remove existing class (needed if theme is being changed)
      bodyElement.classList.remove(activeClass);
      // add next theme class
      bodyElement.classList.add(nextClass);

      this.bodyClass = nextClass;
    }
  }

  getPrevClassIdx(): number {
    return this.currentClassIdx === 0
      ? this.availableClasses.length - 1
      : this.currentClassIdx - 1;
  }

  getNextClassIdx(): number {
    return this.currentClassIdx === this.availableClasses.length - 1
      ? 0
      : this.currentClassIdx + 1;
  }
  ngOnInit() {
    this.renderer.addClass(document.body, 'WalletPage');
    this.paginationOption = environment.pagination;
    this.loggedInUser = this.tokenStorage.getUser();
    if (this.loggedInUser.userdata != undefined) {
      this.userId = this.loggedInUser.userdata.id;
    }
    this.addCashOrContestCashForm = this.formBuilder.group({
      amount: ["", [Validators.required, Validators.pattern(/^[0-9]\d*$/)]],
    });
    this.addCoinForm = this.formBuilder.group({
      amount: ["", [Validators.required, Validators.pattern(/^[0-9]\d*$/)]],
    });
    this.walletCashTypeArray = [
      { name:'All', value:'ALL'},
      { name:'Cash', value:'CASH'},
      // { name:'Contest Cash', value:'CONTESTCASH'},
      { name:'Coins', value:'COINS'},
    ];
    this.fetchSearchResults();
    this.getUserDetails(this.userId)
  }

  onSearchWalletActivity(searchTerm: string) {
    this.searchSubject.next(searchTerm.trim());
  }
    
  fetchSearchResults() {
    this.searchSubscription = this.searchSubject
      .pipe(
        debounceTime(500),                // Wait 500ms after typing stops
        distinctUntilChanged(),            // Only trigger if query changed
      )
      .subscribe((searchTerm) => {
        if (searchTerm !== '' && searchTerm !== null) {
          this.descriptionName = searchTerm;
        } else {
          this.descriptionName = '';
        }
        this.loadWalletHistory(this.lastTableLazyLoadEvent);
      });
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'WalletPage');
  }
  // convenience getter for easy access to form fields
  get f() {
    return this.addCashOrContestCashForm.controls;
  }
  get f1() {
    return this.addCoinForm.controls;
  }

  walletCashTypeFilterSelected(walletCashType: WalletCashType) {
    this.walletCashTypeFilterOption = walletCashType;
    this.isWalletCashTypeTabChanged = true;
    this.loadWalletHistory(this.lastTableLazyLoadEvent);
  }

  loadWalletHistory(event: LazyLoadEvent) {
    this.lastTableLazyLoadEvent = event;
    var query =
      "?filterByDisable=false&filterByUserid=" +
      this.userId +
      "&sortBy=created_at&orderBy=DESC";
    var pagenumber = 1;
    var params = "";
    var rows;
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = event.first / event.rows + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 10;
    }
    // at the time of download hide pagination option
    if (event !== undefined) {
      if (event.first != undefined && event.first == 0) {
        pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        pagenumber = event.first / event.rows + 1;
      } else {
        pagenumber = 1;
      }
      if (event.rows != undefined) {
        rows = event.rows;
      } else {
        rows = 10;
      }
    }

    if (event.sortField != undefined && event.sortOrder != undefined) {
      var orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "DESC";
      } else {
        orderBy = "ASC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }

    if (this.walletCashTypeFilterOption?.value !== 'ALL') {
      query += "&filterByWalletType=" + this.walletCashTypeFilterOption?.value;
    }

    if (this.descriptionName !== '' && this.descriptionName !== null) {
      query += "&filterByDescription=" + this.descriptionName;
    }

    if (this.isWalletCashTypeTabChanged) {
      pagenumber = 1;
      rows = 10;
      this.isWalletCashTypeTabChanged = false;
    }

    this.pageNumberFirst = pagenumber;
    this.pageLimitFirst = rows;

    query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
    this.userWalletService.getUserWalletList(query).subscribe(
      (data) => {
        window.scroll(0, 0);
        this.loading = false;
        this.walletlist = data.data.items;
        this.totalCash = data.data.totalCash;
        this.totalDeductedCash = data.data.totalDeductedCash;
        this.totalAvailableCash = this.totalCash - this.totalDeductedCash;
        this.totalCoins = data.data.totalCoins;
        this.totalDeductedCoin = data.data.totalDeductedCoin;
        this.totalAvailableCoins = this.totalCoins - this.totalDeductedCoin;
        this.totalContestCash = data.data.totalContestCash;
        this.totalDeductedContestCash = data.data.totalDeductedContestCash;
        this.totalAvailableContestCash = this.totalContestCash - this.totalDeductedContestCash;
        this.totalRecords = data.data.totalCount;
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }

  addCashOrMoney(header:string) {
    this.paymentHeader = header;
    this.addCoinmodal = false;
    this.addCashmodal = true;
  }

  onCashOrContestCashSubmit(paymentHeader:string) {
    this.submitted = true;
    if (this.addCashOrContestCashForm.invalid) {
      return;
    }
    var addCashOrContestData = this.addCashOrContestCashForm.value;
    addCashOrContestData["userId"] = this.userId;
    addCashOrContestData["walletType"] = (paymentHeader === 'Add Cash') ? "CASH" : "CONTESTCASH";
    if (addCashOrContestData['amount'] > 0) {
      this.addCashmodal = false;
      const amt = addCashOrContestData["amount"];
      addCashOrContestData = JSON.stringify(addCashOrContestData, null, 4);
      this.walletpaymentService
        .addWalletPayment(addCashOrContestData)
        .subscribe((data) => {
          let options: any = {
            key: environment.RAZORPAY_KEY_ID,
            amount: this.addCashOrContestCashForm.value.amount * 100, // amount should be in paise format to display Rs 1255 without decimal point
            currency: "INR",
            name: "TPL", // company name or product name
            description: "User Added Cash to wallet", // product description
            image: "../../../../assets/images/logo.png", // company logo or product image
            order_id: data.data["orderId"], // user_id created by you in backend
            modal: {
              // We should prevent closing of the form when esc key is pressed.
              escape: false,
            },
            notes: {
              // include notes if any
            },
            theme: {
              color: "#0c238a",
            },
          };
          options.handler = (response, error) => {
            options.response = response;
            let verifyPaymentData = {
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_order_id: response.razorpay_order_id,
              razorpay_signature: response.razorpay_signature,
              userId: this.userId,
              walletType: (paymentHeader === 'Add Cash') ? "CASH" : "CONTESTCASH",
              amount: this.addCashOrContestCashForm.value.amount,
            };
            //commented below code as verify will be done by webhook
            // call your backend api to verify payment signature & capture transaction
            // this.walletpaymentService.verifyWalletpayment(verifyPaymentData).subscribe((paymentdata) => {
            //   window.scroll(0, 0);
            //   this.showThankyouModal = true;
            //   this.addCashOrContestCashForm.reset();
            //   this.addCoinForm.reset();
            //   let currentUrl = this.router.url;
            //   this.router.routeReuseStrategy.shouldReuseRoute = () => false;
            //   this.router.onSameUrlNavigation = "reload";
            //   this.router.navigate([currentUrl]);
            //   //window.location.reload();
            // });
            window.scroll(0, 0);
            this.showThankyouModal = true;
            this.addCashOrContestCashForm.reset();
            this.addCoinForm.reset();
            let currentUrl = this.router.url;
            // this.router.routeReuseStrategy.shouldReuseRoute = () => true;
            // this.router.onSameUrlNavigation = "reload";
            // this.router.navigate([currentUrl]);
            // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            //   this.router.navigate([currentUrl]);
            // });
            window.location.reload();
          };
          options.modal.ondismiss = () => {
            // handle the case when user closes the form while transaction is in progress
            console.log("Transaction cancelled.");
          };
          const rzp = new this.winRef.nativeWindow.Razorpay(options);
          rzp.open();
          return;
        });
    }
  }
  cashclose() {
    this.submitted = false;
    //this.addCashOrContestCashForm.get('amount').reset();
    //this.addCashOrContestCashForm.reset();
  }

  closeThankyou() {
    this.showThankyouModal = false;
    let currentUrl = this.router.url;
    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  addCoin() {
    this.addCashmodal = false;
    this.addCoinmodal = true;
  }

  onCoinSubmit() {
    this.coinsubmitted = true;
    if (this.addCoinForm.invalid) {
      return;
    }
    var addCoinData = this.addCoinForm.value;
    addCoinData["userId"] = this.userId;
    if (addCoinData["amount"] > 0) {
      this.addCoinmodal = false;
      addCoinData = JSON.stringify(addCoinData, null, 4);
      this.walletpaymentService
        .addWalletPayment(addCoinData)
        .subscribe((data) => {
          let options: any = {
            key: environment.RAZORPAY_KEY_ID,
            amount: this.addCoinForm.value.amount * 10 * 100, // amount should be in paise format to display Rs 1255 without decimal point
            currency: "INR",
            name: "TPL", // company name or product name
            description: "User Added Coins to wallet", // product description
            image: "../../../../assets/images/logo.png", // company logo or product image
            order_id: data.data["orderId"], // user_id created by you in backend
            modal: {
              // We should prevent closing of the form when esc key is pressed.
              escape: false,
            },
            notes: {
              // include notes if any
            },
            theme: {
              color: "#0c238a",
            },
          };
          options.handler = (response, error) => {
            options.response = response;
            let verifyPaymentData = {
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_order_id: response.razorpay_order_id,
              razorpay_signature: response.razorpay_signature,
              userId: this.userId,
              walletType: "COINS",
              amount: this.addCoinForm.value.amount,
            };
            // call your backend api to verify payment signature & capture transaction
            this.walletpaymentService
              .verifyWalletpayment(verifyPaymentData)
              .subscribe((paymentdata) => {
                window.scroll(0, 0);
                this.showThankyouModal = true;
                let currentUrl = this.router.url;
                this.addCashOrContestCashForm.reset();
                this.addCoinForm.reset();
                // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                //   this.router.navigate([currentUrl]);
                // });
                window.location.reload();
              });
          };
          options.modal.ondismiss = () => {
            // handle the case when user closes the form while transaction is in progress
            console.log("Transaction cancelled.");
          };
          const rzp = new this.winRef.nativeWindow.Razorpay(options);
          rzp.open();
          return;
        });
    }
  }


  transferAmountToBank(id) {
    this.router.navigate(['my-wallet/wallet-redemption/' + id]);
  }
  convertContestCashToCash(id) {
    console.log(id);
    this.router.navigate(['my-wallet/wallet-conversion/' + id]);
  }

  coinclose() {
    this.coinsubmitted = false;
    //this.addCoinForm.reset();
  }
  downloadPdf(invoiceFile) {
    window.open(invoiceFile);
  }
  getUserDetails(userId){
  this.userService.getUserDetails(userId).subscribe(
    data => {
      this.userAge=data.age
    }
  )}
  onDownloadClick(position: 'left' | 'right' | 'top' | 'bottom' | 'center' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright'){
  this.position = position;
  this.downloadModal = true; 
}
}
